
import { Base } from '../base-component';

import './page-intro-article.component.scss';

export class PageIntroArticle extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/page-intro-article/page-intro-article.component.ts